export const getHeaderCheck = (state) => {
    return state.headerCheck
}